import React from "react";
import { VR_RE_IMAGES } from "../../../data/vrRealEstateImages";

const RealEstateCTA = ({ onBrowseAll, onLearnOwnership }) => {
  const bg = VR_RE_IMAGES.balconyCity;

  return (
    <section className="oshar-re-final-cta" aria-labelledby="oshar-re-final-cta-title">
      <div className="oshar-re-final-cta__bg" style={{ backgroundImage: `url(${bg})` }} />
      <div className="oshar-re-final-cta__veil" />
      <div className="oshar-inner oshar-re-final-cta__inner">
        <h2 id="oshar-re-final-cta-title" className="oshar-re-final-cta__title">
          YOUR PLACE IN OSHAR AWAITS
        </h2>
        <p className="oshar-re-final-cta__sub">
          Choose your district. Claim your role. Build your legacy inside the living city of Treydora.
        </p>
        <div className="oshar-re-final-cta__actions">
          <button type="button" className="oshar-btn-gold oshar-re-btn-wide" onClick={onBrowseAll}>
            Browse All Properties
          </button>
          <button type="button" className="oshar-btn-outline oshar-re-btn-wide" onClick={onLearnOwnership}>
            Learn How Ownership Works
          </button>
        </div>
      </div>
    </section>
  );
};

export default RealEstateCTA;
